import styled from "styled-components";
import UIFormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { EDITOR_MAX_WIDTH, AppTheme } from "components/theme";


export const Row = styled.div`
   display:flex;
   align-items:center;
   justify-content:${props => props.align ? props.align : "space-between"};
   padding:5px 0;
`;



export const FullWidth = styled.div`
    display:block;
    width:100%;
    padding-top:${props => props.paddingTop ? props.paddingTop : 0}    
`;

export const FormControlLabel = styled(UIFormControlLabel)`
    padding-top:10px;
 `;

export const DatePickerContainer = styled.div`
    display: ${props => props.fullWidth ? "block" : "inline-flex"};
    width: ${props => props.fullWidth ? "100%" : "auto"};
   
 `;

export const HtmlEditorContainer = styled.div`
   display: ${props => props.fullWidth ? "block" : "inline-flex"};
   width: ${props => props.fullWidth ? "100%" : "auto"};
   margin:${props => props.margin ? props.margin : "10px 0px 0px 0px"};
   padding-bottom:10px;
   .MuiInputLabel-root{
      display:block;
      transform:scale(0.75);
      padding-bottom:5px;
   }
 
  .wrap-disabled{
   border-radius: 4px;
   border:1px solid #BDBDBD;
   padding: 10px;
  }
 `;

export const FormSection = styled.div`
   display:block;
 `;

export const SelectFormControl = styled(FormControl)`
   margin-top: ${props => props.margin === "normal"? "16px":"0px"};
   margin-bottom: ${props => props.margin === "normal"? "8px":"0px"};
`;

export const InfoData = styled.div`
    display:flex;
    margin:15px 0;
    align-items:center;

    label{
      color: rgba(0, 0, 0, 0.54);
      font-size:0.8rem;
      font-weight:400;
      padding-right:10px;
    }
    .value{
       font-weight:500;
    }
    a{
       color:${AppTheme.palette.primary.main};
    }
 `;

export const EditorSection = styled.div`
   position:relative;
   padding-top:30px;
   max-width:${EDITOR_MAX_WIDTH}
   margin:0px auto;

   .head{
      display:flex;
      align-items:center;
      padding:0px 10px;
      h2{
         flex-grow:1
      }
   }
   .items{
      padding-top:30px;
      display:flex;
      flex-wrap:wrap;
      justify-content: space-between;
   }
`;
